import { apiPaths } from '../config/apiPaths';
import { FrequentlyAskedQuestionResponseDto } from '../modules/FrequentlyAskedQuestions/model/FrequentlyAskedQuestionResponse';
import axiosInstance from './axios';

export const getFrequentlyAskedQuestions = (): Promise<FrequentlyAskedQuestionResponseDto[]> => {
  return axiosInstance
    .get<FrequentlyAskedQuestionResponseDto[]>(apiPaths.FREQUENTLY_ASKED_QUESTIONS)
    .then(({ data }) => data);
};
